import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};

const defaultProps = {
  color: '#27A9E1',
};

const Starburst = ({ color, height, width }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 420 205"
    style={{ enableBackground: 'new 0 0 420 205' }}
    xmlSpace="preserve"
    width={width}
    height={height}
  >
    <g>
      <g id="Layer_1_3_">
        <g id="XMLID_75_">
          <polygon
            id="XMLID_346_"
            fill="#F2F2F2"
            points="154.8,21.4 155,31.1 172.1,25.9 168.8,43.4 186.5,42 179.6,58.4 197.3,60.6 187.2,75.2 203.9,
              81.1 191,93.2 206.2,102.5 191,111.7 203.9,123.9 187.1,129.8 197.3,144.4 179.6,146.6 186.6,163
              168.8,161.5172.1,179 155,173.9 154.8,184.4 420,184.4 420,21.4"
          />
          <path
            id="XMLID_344_"
            fill={color}
            d="M191.1,111.7l15.2-9.2l-15.2-9.2l13-12.2l-16.8-5.9l10.1-14.6l-17.6-2.3l6.9-16.4l-17.8,1.5
              l3.3-17.5l-17,5.1l-0.4-17.8l-15.6,8.6L135,4.5l-13.5,11.6L113.9,0l-10.8,14.2L92.3,0l-7.6,
              16.1L71.3,4.5l-4.1,17.3l-15.6-8.6 L51.1,31l-17-5.1l3.3,17.5l-17.8-1.5l6.9,16.4L8.8,60.6l10.1,
              14.6L2.2,81l13,12.2L0,102.4l15.2,9.2l-13,12.2l16.8,5.9L8.8,144.4 l17.6,2.3l-6.8,16.4l17.7-1.5L34,
              179.1l17-5.1l0.4,17.8l15.6-8.6l4.1,17.3l13.5-11.6l7.6,16.1l10.8-14.2l10.8,14.2l7.6-16.1 l13.5,
              11.6l4.1-17.3l15.6,8.6l0.4-17.8l17,5.1l-3.3-17.5l17.7,
              1.5l-6.9-16.4l17.6-2.3l-10.1-14.6l16.8-5.9L191.1,111.7z"
          />
        </g>
      </g>
    </g>
  </svg>
);

Starburst.propTypes = propTypes;

Starburst.defaultProps = defaultProps;

export default Starburst;
